<template>
    <nav :class="{navBg: $store.state.scrollNavBgStatus}">
        <div class="container">
            <div class="title" @click="toINdex()">
                <div class="logo">
                    <img :src="logoImg" alt="旗渡">
                </div>
                <div class="content">
                    <h2>{{$store.state.cnName}}</h2>
                    <h5>{{$store.state.enName}}</h5>
                </div>
            </div>
            <div class="nav">
<!--                <router-link exact v-for="item in navData" :to="item.path" :key="item.title">{{item.title}}</router-link>-->
                <a v-for="item in navData" href="javascript:void(0)" @click="jumpTo(item.path)" :key="item.title" :class="{active: item.active === $route.meta.active}">{{item.title}}</a>
            </div>
            <div class="minNav">
                <el-dropdown>
                      <span class="el-dropdown-link el-icon-menu minNavIcon" title="菜单"></span>
                        <el-dropdown-menu slot="dropdown" class="minMenu">
                            <el-dropdown-item v-for="item in navData" :key="item.path" :class="{active:isActive(item.path)}">
                                <router-link :to="item.path" :key="item.title">{{item.title}}</router-link>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
    </nav>
</template>

<script>
    export default {
        name: "navBar",
        data() {
            return {
                logoImg: require("@/assets/image/logo.png"),
                navData: [
                    {path: "/translator/index", title: "首页", name: "translator_index", active: "index"},
                    {path: "/translator/material", title: "资料", name: "translator_material", active: "material"},
                    {path: "/translation_task/accept", title: "翻译任务", active: "translation_task"},
                    {path: "/review_task/accept", title: "审校任务", active: "review_task"},
                    {path: "/draft_task/submit", title: "统稿任务", active: "draft_task"},
                    {path: "/task_record", title: "任务记录", active: "task_record"},
                ]
            }
        },
        methods: {
            toINdex() {
                this.$router.push("/translator/index")
            },
            jumpTo(path){
                this.$router.push(path)
            },
            isActive(currentPath){
                let path = this.$route.path;
                if(path.split('/').length>3){
                    let endNum = this.$route.path.lastIndexOf('/')
                    let result = path.substr(0, endNum)
                    return result==currentPath?true:false
                }else{
                    return path==currentPath?true:false
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/css/public/navBar.scss";
</style>